
import { ref, computed } from '@vue/composition-api'
import axios from '@axios'

export default function useUpdateAccumulators() {

  const processes = ref(0);
  const uaDeviceId = ref(null);
  const uaDistance = ref(0);
  const uaHours = ref(0);
  const errors = ref({});

  const uaIsBusy = computed(() => {
    return processes.value > 0;
  })

  const uaDistanceHasValidationError = () => {
    return 'distance' in errors.value;
  }

  const uaDistanceValidationError = () => {
    if(uaDistanceHasValidationError()){
      return errors.value['distance'][0];
    }
    return undefined;
  }

  const uaHoursHasValidationError = () => {
    return 'hours' in errors.value;
  }

  const uaHoursValidationError = () => {
    if(uaHoursHasValidationError()){
      return errors.value['hours'][0] 
    }
    return undefined;
  }

  const refresh = ()=> {
    reset()
    fetchAccumulators()
  }

  const reset = () => {
    uaDistance.value = 0;
    uaHours.value = 0;
    errors.value = {};
  }

  const fetchAccumulators = () => {
    processes.value++;
    axios.get(`/devices/${uaDeviceId.value}/accumulators`)
    .then((response)=> {
      uaDistance.value = response.data.distance
      uaHours.value = response.data.hours
    })
    .finally(() => {
      processes.value--;
    })
  }

  const uaSetDeviceId = (id) => {
    uaDeviceId.value = id
    refresh()
  }

  const uaSubmit = (onSuccess) => {
    processes.value++;
    axios.put(`/devices/${uaDeviceId.value}/accumulators`, {distance:uaDistance.value, hours:uaHours.value})
    .then( response => {
      reset()
      onSuccess()
    })
    .catch( reason => {
      if(reason.response.status == 422){
        errors.value = reason.response.data.errors;
        fetchAccumulators()
      }
    })
    .finally(() => {
      processes.value--;
    })
  }

  return {
    uaDeviceId,
    uaDistance,
    uaHours,
    uaIsBusy,
    uaDistanceHasValidationError,
    uaDistanceValidationError,
    uaHoursHasValidationError,
    uaHoursValidationError,
    uaSetDeviceId,
    uaSubmit
  }
}
